import React from 'react'
import PropTypes from 'prop-types'
import Button from '@material-ui/core/Button'
import Collapse from '@material-ui/core/Collapse'
import CloseIcon from '@material-ui/icons/Close'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { notificationClose } from '../actions'
import styled from 'styled-components'

const Banner = styled(Collapse)`
  && {
    background-color: #484848;
  }
`
const buttonStyles = {
  top: '0px',
  right: '0px',
  float: 'right',
  color: 'rgb(120, 120, 120)',
  background: '#484848'
}

const Notification = ({
  component,
  open,
  notificationCloseDispatch,
  message,
  duration
}) => {
  return (
    <Banner
      onClose={notificationCloseDispatch}
      in={open}
    >
      <Button onClick={notificationCloseDispatch} variant='contained' style={buttonStyles}>Close
      <CloseIcon style={{ fontSize: 16 }} />
      </Button>
      {component}
    </Banner>
  )
}

const mapStateToProps = state => ({
  component: state.common.notificationComponent,
  open: state.common.notificationOpen,
  message: state.common.notificationText,
  duration: state.common.notificationPayload.duration
})

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      notificationCloseDispatch: notificationClose
    },
    dispatch
  )

Notification.propTypes = {
  component: PropTypes.element,
  notificationCloseDispatch: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  message: PropTypes.string,
  duration: PropTypes.number
}

Notification.defaultProps = {
  component: null,
  message: ''
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Notification)
